export const memberFeedbackSurveyJson = {
  showQuestionNumbers: "off",
  showCompletedPage: false,
  showPageTitles: false,
  completeText: "Send feedback",
  pages: [
    {
      name: "member-feedback",
      elements: [
        {
          type: "html",
          name: "feedback-intro",
          html: `<h3 style="margin:0 0 8px;">Thank you for being a Genomic Life member</h3>
<p style="margin:0;color:#222222;">We appreciate your feedback!</p>`
        },
        {
          type: "rating",
          name: "experience-rating",
          title: "How would you rate your experience so far?",
          isRequired: true,
          rateType: "stars",
          rateCount: 5,
          rateMin: 1,
          rateMax: 5
        },
        {
          type: "boolean",
          name: "would-recommend-genomic-life",
          title: "Would you recommend Genomic Life to family or friends?",
          isRequired: true,
          labelTrue: "Yes",
          labelFalse: "No"
        },
        {
          type: "comment",
          name: "what-worked-well",
          title: "What's worked well? What could be improved?",
          description: "Please share what's on your mind.",
          rows: 5
        }
      ]
    }
  ]
} as const;
